import { EMPTY_CHARGE_ON_COMPANY_MAPPING_MODEL } from 'presentation/model/ChargeOnCompanyMapping/ChargeOnCompanyMappingModel';
import { useState } from 'react';
import { createContainer } from "react-tracked";

const {
    Provider: ChargeOnCompanyMappingProvider,
    useTracked: useChargeOnCompanyMappingTracked
} = createContainer(() => useState(EMPTY_CHARGE_ON_COMPANY_MAPPING_MODEL), {concurrentMode: true});
export { ChargeOnCompanyMappingProvider, useChargeOnCompanyMappingTracked };

